export const USER_GENDER_OPTIONS = [
  { value: 'FEMENINE', label: 'Femenino' },
  { value: 'MASCULINE', label: 'Masculino' },
  { value: 'NO_BINARY', label: 'No binario' },
  { value: 'OTHER', label: 'Prefiero no especificar' }
]
